import { createBrowserHistory } from 'history';

import { getBasePathFromLocation } from './api';

export default createBrowserHistory({
    basename: getBasePathFromLocation(window.location)
});
